<template>
	<div class="container">
		<div class="row">
			<sidebar></sidebar>
			<div class="col-sm-10">
			<!-- Empty car-->
				<section class="account-section">
					<h2>Cambiar contraseña</h2>
					<form class="form-horizontal" role="form" @submit="changePass">
						<div class="row form-group">
						    <label class="control-label col-sm-3" for="password">Contraseña actual</label>
						    <div class="col-sm-5">
						      <input type="password" class="form-control" :class="{ 'has-error': err.current_password }" id="password" v-model="form.current_password">
						        <div class="tooltip-error" v-if="err.current_password">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa tu contraseña actual para continuar.
						      	</div>
						    </div>
					 	</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="password2">Contraseña nueva</label>
							<div class="col-sm-5">
							  <input type="password" class="form-control" :class="{ 'has-error': err.new_password || err.match_new_password}" id="password2" v-model="form.new_password">
							    <div class="tooltip-error" v-if="err.new_password">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa tu nueva contraseña para continuar.
					      	    </div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="password2">Confirmar nueva contraseña</label>
							<div class="col-sm-5">
							  <input type="password" class="form-control" :class="{ 'has-error': err.confirm_new_password || err.match_new_password }" id="password2" v-model="form.confirm_new_password">
							  	<div class="tooltip-error" v-if="err.confirm_new_password">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Confirma tu nueva contraseña para continuar
					      	  	</div>
					      	  	<div class="tooltip-error" v-if="err.match_new_password">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Las contraseñas no coinciden
					      	  	</div>
							</div>
						</div>
						<div class="form-group"> 
							<!--<div v-if="has_error" class="error">{{ msg_error }}</div>-->
						    <div class="col-sm-offset-3 col-sm-5">
						      <button type="submit" class="btn btn-black btn-lg">Guardar</button>
						    </div>
						</div>
					</form>
				</section>
			</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/User/Breadcrumb.vue';
import Sidebar from '../../components/User/Sidebar.vue';
import { updateMe } from '../../store/actions';

export default {
	data() {
		return {
			has_error: false,
			msg_error: null,
			err: {},
			form: {
				current_password: '',
				new_password: '',
				confirm_new_password: '',
				match_new_password: '',
			}
		}
	},

	vuex: {
		getters: {
			user: state => state.current_user
		},
		actions: {
			updateMe
		}
	},
	
	methods: {
		changePass(e) {
			e.preventDefault();
			this.has_error = false;
			this.msg_error = null;
			this.err = {};
			this.validate();

			// Fix the tooltip for xs and sm screens.
			$(window).resize( function(){
				if ($(window).width()<778){
					setTimeout( function(){
						$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
						$(".tooltip-error").addClass("center-block");
						$(".top-caret").css("display", "none");
					}, 10);
				}else{
					setTimeout( function(){
						$(".tooltip-error").css({"position": "absolute", "margin-top" : "0"});
						$(".tooltip-error").addClass("center-block");
						$(".top-caret").css("display", "block");
					}, 10);
				}
			});

			if (this.has_error) {
				return;
			}

			this.form.token = this.user.token;
			this.updateMe(this.form);
			e.target.reset();
		},

		validate() {
			if (!this.form.current_password) {
				this.has_error = true;
				//this.msg_error = 'Introduce tu contraseña actual.';
				this.err.current_password = true;
			}

			if (!this.form.new_password) {
				this.has_error = true;
				//this.msg_error = 'Introduce la nueva contraseña.';
				this.err.new_password = true;
			}

			if (!this.form.confirm_new_password) {
				this.has_error = true;
				//this.msg_error = 'Introduce la nueva contraseña.';
				this.err.confirm_new_password = true;
			}

			if (this.form.new_password != this.form.confirm_new_password) {
				this.has_error = true;
				this.err.match_new_password = true;
			}
		}
	},

  components: {
  	Breadcrumb,
  	Sidebar
  }
};
</script>


// WEBPACK FOOTER //
// Config-password.vue?5c2f03ae